export default  {
    component: 'user_plant_config',
    name: 'user_plant_config',
    fields: [
          {
            name: "Plant",
            param: 'plant_id',
            type: 'number',
            required: true,
            identifier: true
          },
          {
            name: 'User ID',
            param: 'user_id',
            type: 'number',
            required: true,
            identifier: true
          },
          {
            name: 'Logo',
            param: 'logo',
            type: 'text',
          },
          {
            name: 'Daily Digest Status',
            param: 'daily_digest_status',
            type: 'text',
          },
          {
            name: 'Alert Mail Notification',
            param: 'alert_mail_notification',
            type: 'text',
          },
          {
            name: 'Rule ID',
            param: 'rule_id',
            type: 'text',
          },
          {
            name: 'Notificaiton Config',
            param: 'notificaiton_config',
            type: 'json',
          },
          {
            name: 'Notification Enable',
            param: 'notification_enable',
            type: 'number',
          }
  // device_id
  // inverter_name
  // added_on
  // updated_on
  // updated_by
  // inverter_room
    ]
  }







